import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TSyaryoCountListGetRes } from "./TSyaryoCount"

/**
 * 車輌台数に対するAPIリクエスト用サービス
 *
 * @export
 * @class SyaryoCountService
 * @extends {ConnectApi}
 */
export default class SyaryoCountService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyaryoListGetReq} params
   * @param {(param: TApiResponse<TSyaryoListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TSyaryoListGetRes>) => any} reject
   * @memberof SyaryoService
   */
  getList = async () => {
    try {
      const res: AxiosResponse<TApiResponse<TSyaryoCountListGetRes>> =
        await this.getInner(`/truck/syaryocount`, {})
      return res.data
    } catch (err) {
      throw err
    }
  }
}
